<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lsNOlq/tc-custom/9781635765137.jpg?1718078950216" alt="This image is the cover for the book Split Worlds Omnibus, The Split Worlds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Split Worlds Omnibus, The Split Worlds
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Now in one volume: the first three novels in the urban fantasy series “</b><b>that playfully mixes magic and interesting characters into an intriguing mystery” (</b><b><i>Kirkus Reviews</i></b><b>).</b><br/><br/> Between Mundanus, the world of humans, and Exilium, the world of the Fae, lies the Nether, a mirror-world where the social structure of 19th-century England is preserved by Fae-touched families who remain loyal to their ageless masters. Born into this world is Catherine Rhoeas-Papaver, who escapes it all to live a normal life in Mundanus, free from her parents and the strictures of Fae-touched society. But now she’s being dragged back to face an arranged marriage, along with all the high society trappings it entails. <br/><br/> Crossing paths with Cathy is Max, an Arbiter of the Split Worlds treaty with a dislocated soul who polices the boundaries between the worlds, keeping innocents safe from the Fae. After a spree of kidnappings and the murder of his fellow Arbiters, Max is forced to enlist Cathy’s help in unravelling a high-profile disappearance within the Nether. Getting involved in the machinations of the Fae, however, may prove fatal to all involved. <i>The Split Worlds Omnibus</i>—spanning <i>Between Two Thorns</i>, <i>Any Other Name</i>, and <i>All Is Fair</i>—presents the intricately plotted and delightfully suspenseful world Emma Newman has crafted.</p><p><b>Praise for the Split Worlds series</b></p><p>“JK Rowling meets Georgette Heyer . . . Newman renders the Split Worlds with verve and an infectious sense of fun, and presents in Cathy a strong and personable heroine.”—<i>The Guardian</i></p> “Learning to be a young lady has never seemed so dangerous.”—Mary Robinette Kowal, Hugo and Nebula Award-winning author of the Lady Astronaut series
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Newman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43bba1d4